import { PageChrome, ROUTES } from '@/components/gg/chrome'
import { Profile } from '@/pages/Profile'

/** Profile (/app/profile): your name, photo and email. Reached from Settings. */
export function ProfilePage() {
  return (
    <>
      <PageChrome title="Profile" navKey="settings" back={{ to: ROUTES.settings, label: 'Settings' }} />
      <div className="gg-legacy"><Profile /></div>
    </>
  )
}
